import React, { Suspense, lazy } from 'react'
import { Routes, Route } from 'react-router-dom'
import { createGlobalStyle } from 'styled-components'
import { ScrollToTop, Loader } from '../common/components'
import { colors } from '../common/theme'
import NexaBold from './assets/nexa-bold.otf'
import NexaLight from './assets/nexa-light.otf'
import { AuthProvider } from '../features/auth/context'

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
  }

  html, body, #app {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    font-family: 'Source Sans Pro', -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    font-size: 0.95em;
    background: ${colors.background};
    color: ${colors.foreground};
  }

  ::selection {
    background: ${colors.primary};
    color: white;
  }

  ::-moz-selection {
    background: ${colors.primary};
    color: white;
  }

  .grabbing {
    cursor: move; /* fallback */
    cursor: grabbing;
  }

  @font-face {
    font-family: NexaBold;
    src: url('${NexaBold}') format('opentype');
  }

  @font-face {
    font-family: NexaLight;
    src: url('${NexaLight}') format('opentype');
  }
`

const LoadableHome = lazy(() => import('./pages/Home'))
const LoadableGenerator = lazy(() => import('./pages/Generator'))
const LoadableAbout = lazy(() => import('./pages/About'))
const LoadablePrivacy = lazy(() => import('./pages/Privacy'))
const LoadableError404 = lazy(() => import('./pages/Error404'))

function App() {
  return (
    <AuthProvider>
      <GlobalStyle />
      <ScrollToTop>
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route
              path="/googlea8f6613e9d7163d1.html"
              element={
                <div>google-site-verification: googlea8f6613e9d7163d1.html</div>
              }
            />
            <Route path="/" element={<LoadableHome />} />
            <Route path="/generator" element={<LoadableGenerator />}>
              <Route path="*" element={<LoadableGenerator />} />
            </Route>
            <Route
              path="/generator/:resumeId/*"
              element={<LoadableGenerator />}
            />
            <Route path="/about" element={<LoadableAbout />} />
            <Route path="/privacy" element={<LoadablePrivacy />} />
            <Route path="*" element={<LoadableError404 />} />
          </Routes>
        </Suspense>
      </ScrollToTop>
    </AuthProvider>
  )
}

export default App
